import React from "react";
import { useTranslation } from "react-i18next";
import Form from "react-bootstrap/Form";
import NavDropdown from "react-bootstrap/NavDropdown";
import { Globe } from "react-bootstrap-icons";
import { getTextWithCapitalizedFirstLetter } from "../../helpers/textHelper";

interface LanguageSelectorProps {
  useNav: boolean;
  className: string;
}

const LanguageSelector = (props: LanguageSelectorProps) => {
  const { i18n } = useTranslation();

  const changeLanguage = (event: React.ChangeEvent<HTMLSelectElement>) => {
    i18n.changeLanguage(event.target.value);
  };

  const changeLanguageByCode = (language: string) => {
    i18n.changeLanguage(language);
  };

  const getDisplayLanguage = () => {
    let language = i18n.language;
    return getTextWithCapitalizedFirstLetter(language);
  };

  if (props.useNav) {
    return (
      <NavDropdown
        align="end"
        className={"no-caret " + props.className}
        title={
          <>
            <Globe className="me-2 header-icon" />
            {getDisplayLanguage()}
          </>
        }
      >
        <NavDropdown.Item
          onClick={() => {
            changeLanguageByCode("en");
          }}
        >
          English
        </NavDropdown.Item>
        <NavDropdown.Item
          onClick={() => {
            changeLanguageByCode("de");
          }}
        >
          Deutsch
        </NavDropdown.Item>
        <NavDropdown.Item
          onClick={() => {
            changeLanguageByCode("fr");
          }}
        >
          Français
        </NavDropdown.Item>
      </NavDropdown>
    );
  }

  return (
    <Form.Select value={i18n.language} onChange={changeLanguage}>
      <option value="en">English</option>
      <option value="de">Deutsch</option>
      <option value="fr">Français</option>
    </Form.Select>
  );
};

export default LanguageSelector;
